<div role="contentinfo" class="footer text-white text-center">
  <!--Sponsors-->
  <div class="footer-primary">
    <hr class="text-secondary" />
    <div class="font-size-14 fw-bold text-uppercase">{{ 'footer.club.partners' | translate }}</div>
    <hr class="text-secondary" />
  </div>

  <a href="{{ 'footer.amex.url' | translate }}">
    <img alt="" class="amex-logo" [src]="'footer/brands/amex.png' | contentAssetImage" draggable="false" />
  </a>

  <div class="footer-second-row">
    <a href="{{ 'footer.kissimmee.url' | translate }}">
      <img alt="" class="brand-logo" [src]="'footer/brands/kissimmee.png' | contentAssetImage" draggable="false" />
    </a>
    <a href="{{ 'footer.nike.url' | translate }}">
      <img alt="" class="brand-logo" [src]="'footer/brands/nike.png' | contentAssetImage" draggable="false" />
    </a>
    <a href="{{ 'footer.pinterest.url' | translate }}">
      <img alt="" class="brand-logo" [src]="'footer/brands/pinterest.png' | contentAssetImage" draggable="false" />
    </a>
  </div>

  <ng-container *inPopulation="[populations.Default, populations.Club1901]">
    <!--Social Icons-->
    <div class="footer-primary">
      <hr class="text-secondary" />
      <div class="font-size-14 fw-bold text-uppercase">{{ 'footer.club.socials' | translate }}</div>
      <hr class="text-secondary" />
    </div>

    <div class="footer-socials-wrapper">
      <div class="footer-socials">
        <div class="club-socials club-socials-club">
          <div class="font-size-14 fw-bold text-uppercase">{{ 'footer.club.socials.club' | translate }}</div>
          <a href="{{ 'footer.club.facebook.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/facebook.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.club.whatsapp.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/whatsapp.png' | contentAssetImage" draggable="false" />
          </a>
        </div>

        <div class="club-socials club-socials-mens">
          <div class="font-size-14 fw-bold text-uppercase">{{ 'footer.club.socials.men' | translate }}</div>
          <a href="{{ 'footer.mens.twitter.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/twitter.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.mens.youtube.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/youtube.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.mens.instagram.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/instagram.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.mens.threads.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/threads.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.mens.tiktok.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/tiktok.png' | contentAssetImage" draggable="false" />
          </a>
        </div>

        <div class="club-socials club-socials-womens">
          <div class="font-size-14 fw-bold text-uppercase">{{ 'footer.club.socials.women' | translate }}</div>
          <a href="{{ 'footer.womens.pinterest.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/pinterest.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.womens.twitter.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/twitter.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.womens.youtube.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/youtube.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.womens.instagram.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/instagram.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.womens.threads.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/threads.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.womens.tiktok.url' | translate }}">
            <img alt="" class="socials-icon" [src]="'footer/socials/tiktok.png' | contentAssetImage" draggable="false" />
          </a>
        </div>
      </div>

      <!--App Icons-->
      <div class="footer-app-icons">
        <a href="{{ 'footer.android.url' | translate }}">
          <img alt="" class="app-icon" [src]="'footer/apps/android.png' | contentAssetImage" draggable="false" />
        </a>
        <a href="{{ 'footer.apple.url' | translate }}">
          <img alt="" class="app-icon" [src]="'footer/apps/apple.png' | contentAssetImage" draggable="false" />
        </a>
      </div>
    </div>

    <hr class="text-secondary footer-divider-bottom" />
  </ng-container>
</div>
